import { render, staticRenderFns } from "./AreaPanel.vue?vue&type=template&id=0b9a1f7c&scoped=true&"
import script from "./AreaPanel.vue?vue&type=script&lang=js&"
export * from "./AreaPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9a1f7c",
  null
  
)

export default component.exports